import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import queryStringify from "qs-stringify";

Vue.use(Vuex);

export default {
    name: "numpy",
    state: {

    },
    getters: {

    },
    mutations: {

    },
    actions: {
        getPurchaseOrders: (context , payload)=>{
            payload = {
                ...payload,
                ...context.getters.getGlobalDateRange
            }
            return axios.get(numpyTomcatApi+`numpy/purchase_order`,{
                params : payload
            }).then(({data})=>data).catch(err=>errorHandler.tomcatError(err))
        },
        searchSupplier:(context , supplierName)=>{
            supplierName = `?${queryStringify({supplierName})}`;
            return axios.get(numpyTomcatApi+`supplier`+supplierName)
                .then(({data})=>data)
                .catch(err=>errorHandler.tomcatError(err))
        }
    }
}
